import React, { useEffect, useState } from "react";
import moment from "moment-timezone";
import { Form, Select } from "antd";

const TimeZoneSelect = ({ value, onChange, ...rest }) => {
  const [timeZoneOptions, setTimeZoneOptions] = useState([]);

  const generateOptions = () =>
    moment.tz.names().map((tz) => {
      const currentTime = moment().tz(tz).format("HH:mm");
      return {
        value: tz,
        label: `${tz} - ${currentTime}`,
      };
    });

  useEffect(() => {
    setTimeZoneOptions(generateOptions());

    // ⏱ refresh every minute
    const interval = setInterval(() => {
      setTimeZoneOptions(generateOptions());
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Select
      {...rest}
      value={value}
      onChange={onChange}
      showSearch
      placeholder="Select Time Zone"
      optionFilterProp="children"
      filterOption={(input, option) =>
        option?.label.toLowerCase().includes(input.toLowerCase())
      }
      options={timeZoneOptions}
    />
  );
};

export default TimeZoneSelect;
